<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="url,http_type,status_message,result_data,data"
      :default-sorter="[{ direction: 'DESC', property: 'id' }]"
      :show-export="false"
      :show-custom-column="true"
      ref="htTable"
    >
      <template v-slot:search>
        <eco-table-search-panel :divide="3" :label-width="100">
          <eco-table-search-field label="ID" prop="id" :label-width="100" />
        </eco-table-search-panel>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="dock_type" label="对接类型" :sortable="true" :show-overflow-tooltip="true" :filters="typeArray">
          <template v-slot="{ row }">
            <el-tag v-show="row.dock_type == s.value" type="info" v-for="s in typeArray" :key="s.value">{{ s.text }}</el-tag>
          </template>
        </eco-table-column>
        <eco-table-column prop="data" label="请求体" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
        <eco-table-column prop="url" label="请求url地址" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
        <eco-table-column prop="http_type" label="请求方式" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
        <eco-table-column prop="status_message" label="状态说明" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
        <eco-table-column prop="result_data" label="返回数据" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
        <eco-table-column prop="createTime" label="请求时间" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
        <eco-table-column label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-link v-if="row.dock_type === '6'" :underline="false" @click="showRetryDialog(row)" type="primary">回调</el-link>
            <el-link :underline="false" @click="reinvoke(row.id)" type="primary" v-else>重调</el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>
    <el-dialog title="数据回调" :visible.sync="dialogVisibleReturn" width="80%" :before-close="handleCloseReturn" :close-on-click-modal="false" append-to-body>
      <el-container class="dialogReturn">
        <el-form :model="dialogRowReturn" data-vv-scope="sysTypeForm" style="padding: 20px">
          <eco-form-item label="请求地址" label-width="100px">
            <eco-input type="textarea" v-model="dialogRowReturn.url" :maxlength="1000"></eco-input>
          </eco-form-item>
          <eco-form-item label="请求方式" label-width="100px">
            <eco-input v-model="dialogRowReturn.http_type"></eco-input>
          </eco-form-item>
          <eco-form-item label="请求体" label-width="100px">
            <eco-input type="textarea" v-model="dialogRowReturn.data" :maxlength="500000"></eco-input>
          </eco-form-item>
        </el-form>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleReturn">重新发起</el-button>
        <el-button size="small" @click="handleCloseReturn">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import req from '@/request.js'

export default {
  data() {
    return {
      dialogVisible: false,
      data: [],
      dialogVisibleReturn: false,
      dialogRowReturn: {
        data: '',
        url: '',
        http_type: ''
      },
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      portal_sys_http_logs: {
        create_user_id: this.$store.state.user.currentUserDetail.user.userId,
        create_user: this.$store.state.user.currentUserDetail.user.fullname,
        create_dept_id: this.$store.state.user.currentUserDetail.user.groupId
      },
      saveMethod: 'POST',
      formConfig: {},
      formList: [],
      typeArray: [
        { text: '软件基础模块', value: '1' },
        { text: 'BI系统', value: '2' },
        { text: '企查查基础数据查询', value: '3' },
        { text: '企查查风险监控', value: '4' },
        { text: '发票税务信息', value: '5' },
        { text: '财务系统', value: '6' },
        { text: '支付宝', value: '7' },
        { text: 'OCR', value: '8' },
        { text: '银企直联(招行CBS)', value: '9' },
        { text: 'E签宝', value: '10' },
        { text: '钉钉考勤机', value: '13' }
      ]
    }
  },
  mounted() {
    this.$validator = this.$root.$validator
  },
  methods: {
    // 下划线转驼峰
    toHump(name) {
      const a = name.split('_')
      const arr = ['']
      a.forEach((b) => {
        b = b.slice(0, 1).toUpperCase() + b.slice(1)
        arr.push(b)
      })
      const upper = arr.join('')
      return upper.replace(upper[0], upper[0].toLowerCase())
    },
    showDialog(id) {
      // 表单配置json加载 TODO 修改key
      this.$http.get('${form}/form/form/v1/getFormByKey?key=sysHttpLogs').then((resp) => {
        const data = JSON.parse(resp.data.expand).list
        data.forEach((item) => {
          if (item.columns) {
            item.columns.forEach((column) => {
              column.list.forEach((field) => {
                //field.name = this.toHump(field.name);
                if (field.options.validate) {
                  this.formConfig[field.name] = (field.options.validate + '').replace(/\'/g, '')
                } else {
                  this.formConfig[field.name] = null
                }
              })
            })
          } else {
            item.name = this.toHump(item.name)
            if (item.options.validate) {
              this.formConfig[item.name] = (item.options.validate + '').replace(/\'/g, '')
            } else {
              this.formConfig[item.name] = null
            }
          }
        })
        this.formConfig = _.cloneDeep(this.formConfig)
        this.formList = data
      })
      if (id) {
        this.saveMethod = 'PUT'
        this.$http.get('${portal}/sysHttpLogs/' + id).then(
          (resp) => {
            this.portal_sys_http_logs = resp.data
            this.dialogVisible = true
          },
          (error) => {
            reject(error)
          }
        )
      } else {
        this.saveMethod = 'POST'
        this.dialogVisible = true
      }
    },
    beforeCloseDialog() {
      this.portal_sys_http_logs = {}
      this.dialogVisible = false
    },
    loadData(param, cb) {
      this.$http
        .post('${log}/httpLogs/query', param)
        .then(
          (resp) => {
            let response = resp.data
            this.data = response.rows
            this.pageResult = {
              page: response.page,
              pageSize: response.pageSize,
              total: response.total
            }
          },
          (error) => {
            reject(error)
          }
        )
        .finally(() => cb())
    },
    afterSaveData() {
      setTimeout(() => {
        this.beforeCloseDialog()
        this.$refs.htTable.load()
      }, 500)
    },
    // 返回数据查看
    showRetryDialog(row) {
      this.dialogVisibleReturn = true
      this.dialogRowReturn.data = row.data
      this.dialogRowReturn.url = row.url
      this.dialogRowReturn.http_type = row.http_type
    },
    // 回调
    handleCloseReturn() {
      this.dialogVisibleReturn = false
      this.dialogRowReturn = {
        data: '',
        url: '',
        http_type: ''
      }
    },
    handleReturn() {
      let params = {
        data: {
          ...this.dialogRowReturn
        },
        url: '${third}/voucher_process/pushByHttpLog',
        method: 'POST'
      }
      this.$http.request(params).then(
        (resp) => {
          this.handleCloseReturn()
          this.$refs.htTable.load()
        },
        (error) => {
          console.log(error, 123123)
        }
      )
    },

    reinvoke(id) {
      let this_ = this
      req.post(req.getContext().portal + '/portal/sysHttpLogs/v1/reinvoke/' + id).then(function (response) {
        let data = response.data
        if (data.state) {
          this_.$message.success(data.message)
          this_.$refs.ecoTable.load()
        } else {
          this_.$message.fail(data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
